export const phoneValidations = /^((39)|(50)|(63)|(66)|(67)|(68)|(73)|(75)|(77)|(89)|(91)|(92)|(93)|(94)|(95)|(96)|(97)|(98)|(99))\d{0,7}$/
